export const GET_COLLECTION_ORDER_STATUS_REQUEST = 'GET_COLLECTION_ORDER_STATUS_REQUEST'
export const GET_COLLECTION_ORDER_STATUS_SUCCESS = 'GET_COLLECTION_ORDER_STATUS_SUCCESS'
export const GET_COLLECTION_ORDER_STATUS_ERROR = 'GET_COLLECTION_ORDER_STATUS_ERROR'
export const GET_COLLECTION_ORDER_STATUS_RESET = 'GET_COLLECTION_ORDER_STATUS_RESET'